import React from 'react'
import PropTypes from 'prop-types'

import Popover from 'material-ui/Popover'
import DayPicker from 'react-day-picker'
import moment from 'moment'

import closeIcon from 'resources/close_icon.png'
import pickerStyles from 'common/DayPickerStyle.css'

const Header = ({ billingEntity, onCloseClicked }) => 
  <div style={styles.header}>
    <div style={styles.heading}>
      { billingEntity === 'estimate' ? 'Expires On' : 'Payment Due' }
    </div>
    <img src={closeIcon} title='Close' width={16}
      onClick={onCloseClicked}
      style={{ cursor: 'pointer' }} />
  </div>

Header.propTypes = {
  billingEntity: PropTypes.string.isRequired,
  onCloseClicked: PropTypes.func.isRequired
}

const handleEasyAccessClicked = (event, billDate, days, onDateSelected) => {
  event.preventDefault()
  onDateSelected(billDate.clone().add(days, 'days'))
}

const EasyAccessItem = ({ days, onClick }) =>
  <div style={styles.easyAccessItem} onClick={event => onClick(event, days)}>
    { days === 0 ? 'On Receipt' : `Within ${days} Days` }
  </div>

EasyAccessItem.propTypes = {
  days: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired
}

const Content = ({ billDate, onDateSelected }) => {

  return <div style={styles.content}>
    <DayPicker
      fixedWeeks={true}
      firstDayOfWeek={0}
      onDayClick={date => onDateSelected(moment(date))}
      month={moment().toDate()}
      disabledDays={{ before: moment().toDate() }}
      selectedDays={moment().toDate()} />
    <div style={styles.separator} />
    <div style={styles.easyAccess}>
      { [0, 15, 30, 45, 60, 90].map(days =>
        <EasyAccessItem
          key={days}
          days={days}
          onClick={(event, days) => handleEasyAccessClicked(event, billDate, days, onDateSelected)} />)
      }
    </div>
  </div>
  
}

Content.propTypes = {
  onDateSelected: PropTypes.func.isRequired,
  billDate: PropTypes.object.isRequired
}

export default class PaymentDueDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    billDate: PropTypes.object.isRequired,
    billingEntity: PropTypes.string.isRequired,
    anchorElement: PropTypes.object,
    onDateSelected: PropTypes.func.isRequired,
    onCloseRequested: PropTypes.func.isRequired
  }

  handleCloseClicked = event => {
    event.preventDefault()
    this.props.onCloseRequested()
  }

  render() {
    if (!this.props.open) {
      return null
    }
    return (
      <Popover
        open={this.props.open}
        anchorEl={this.props.anchorElement}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        useLayerForClickAway={false} // Avoid flashy effect when rendering the popover.
        onRequestClose={this.props.onCloseRequested}>
        <Header onCloseClicked={this.handleCloseClicked} billingEntity={this.props.billingEntity} />
        <Content billDate={this.props.billDate} onDateSelected={this.props.onDateSelected} />
      </Popover>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    display: 'flex',
    flexDirection: 'row'
  },
  header: {
    display: 'flex',
    displayDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 12,
    backgroundColor: '#fafafa'
  },
  heading: {
    fontSize: 16,
    color: '#212121'
  },
  separator: {
    display: 'flex',
    width: 1,
    backgroundColor: '#fafafa'
  },
  easyAccess: {
    display: 'flex',
    flexDirection: 'column',
    margin: 16
  },
  easyAccessItem: {
    marginBottom: 10,
    cursor: 'pointer',
    color: '#356992',
    fontSize: 16
  }
}



// WEBPACK FOOTER //
// ./src/billing/common/modules/header/paymentDue/PaymentDueDialog.js